export enum ApprovalStatus 
{
    Pending,
    Approved,
    Rejected
}

export const ApprovalStatusDescriptions: { [key in ApprovalStatus | any]: string} = {
    [ApprovalStatus.Pending]: "Pending",
    [ApprovalStatus.Approved]: "Approved",
    [ApprovalStatus.Rejected]: "Rejected"
}